// Interceptors.js
// Sets up Axios interceptors for request/response
import TokenManager from './TokenManager';

export default function setupInterceptors(axiosInstance, apiService) {
    axiosInstance.interceptors.request.use(
        async (config) => {
            // Optionally add more request logic here
            return config;
        },
        (error) => Promise.reject(error)
    );

    axiosInstance.interceptors.response.use(
        (response) => response,
        async (error) => {
            const { response, config } = error;
            if (response && (response.status === 501 || response.status === 522)) {
                // Token expired, queue the failed request and refresh token
                return new Promise(async (resolve, reject) => {
                    const key = apiService._getRequestKey(config.url, config.method, config.data, config.params);
                    let tracker, metaObj;
                    if (apiService.pendingRequests.has(key)) {
                        ({ meta: metaObj } = apiService.pendingRequests.get(key));
                        tracker = metaObj.tracker || null;
                    }
                    // If not found, fallback to new tracker/metaObj (should not happen in normal flow)
                    if (!metaObj) {
                        tracker = new RequestTracker({ url: config.url, method: config.method, data: config.data, params: config.params });
                        metaObj = {
                            ...tracker.getMeta(),
                            status: 'waiting_token',
                            retries: 0,
                            abort: () => apiService.abortRequest(key),
                        };
                        apiService.pendingRequests.set(key, { meta: metaObj, abortController: new AbortController() });
                    } else {
                        metaObj.status = 'waiting_token';
                    }
                    apiService.retryManager.queueRequest({ config, key, tracker, metaObj });
                    apiService.emit('status', { key, meta: metaObj, error });
                    try {
                        await TokenManager.refreshToken();
                        const newToken = TokenManager.getToken();
                        config.headers['Authorization'] = newToken;
                        if (typeof apiService.setToken === 'function') {
                            apiService.setToken(newToken);
                        }
                        // Optionally: dispatch Redux update if callback is set
                        if (typeof apiService.onTokenUpdate === 'function') {
                            apiService.onTokenUpdate(newToken);
                        }
                        apiService.pendingRequests.delete(key);
                        apiService.abortControllers.delete(key);
                        const resp = await axiosInstance(config);
                        resolve(resp);
                    } catch (e) {
                        console.error("Token refresh call failed:", e);
                        reject(e);
                    }
                });
            }
            return Promise.reject(error);
        }
    );
}
